const isDate = value => {
    if (typeof(value) === 'object') {
        if (value instanceof Date) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
};
export {isDate}



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/typeValidate.js